import { GlobalsService } from './../globals.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../http.service';
import { HttpClient } from '@angular/common/http';
import { ScienceCategory } from './science-category';
import { ScienceKeyword } from './science-keyword';

@Injectable({
  providedIn: 'root'
})
export class TabExpertiseService {

  private readonly READ_EXPERTISE_CATEGORY = '/science-categories';
  private readonly READ_EXPERTISE_KEYWORD = '/expertise';
  private readonly SAVE_EXPERTISE_KEYWORD = '/save-expertise';

  constructor(private globals: GlobalsService,
    private httpService: HttpService, private httpClient: HttpClient) {
  }

  fetchCategories(): Observable<ScienceCategory[]> {
      return this.httpService.getJson(`${this.READ_EXPERTISE_CATEGORY}`)
  }
  
  fetchKeywords(): Observable<ScienceKeyword[]> {
    //const accountId = this.globals.account !== undefined ? this.globals.accountId.replace(/ /g, '\u00a0') : "";
    //console.log('AccountId ' + JSON.stringify(accountId));
    return this.httpService.getJson(`${this.READ_EXPERTISE_KEYWORD}`);
  }

  submitKeywords(keywords: ScienceKeyword[]): Observable<any> {
    const url = `${this.globals.apiURL}${this.SAVE_EXPERTISE_KEYWORD}`;

    const keywordsCodes: string[] = [];
    keywords.forEach(keyword => {
      if (keyword !== null && keyword !== undefined && keyword.code !== "") {
		keywordsCodes.push(keyword.code);
      }
    });

    const params: any = {};
    params['keywordCodes'] = keywordsCodes;
    console.log('POST Parameters ' + JSON.stringify(params));
    return this.httpClient.post(url, keywordsCodes, { withCredentials: true });
  }

}
